import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './encrypt-duty-free-preorder-result.actions';
import { EncryptDutyFreePreorderResultState } from './encrypt-duty-free-preorder-result.state';

/**
 * encryptDutyFreePreorderResult initial state
 */
export const encryptDutyFreePreorderResultInitialState: EncryptDutyFreePreorderResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for EncryptDutyFreePreorderResult Store
 */
export const encryptDutyFreePreorderResultReducerFeatures: ReducerTypes<
  EncryptDutyFreePreorderResultState,
  ActionCreator[]
>[] = [
  on(actions.setEncryptDutyFreePreorderResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateEncryptDutyFreePreorderResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetEncryptDutyFreePreorderResult, () => encryptDutyFreePreorderResultInitialState),

  on(actions.cancelEncryptDutyFreePreorderResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failEncryptDutyFreePreorderResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setEncryptDutyFreePreorderResultFromApi,
    actions.updateEncryptDutyFreePreorderResultFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * EncryptDutyFreePreorderResult Store reducer
 */
export const encryptDutyFreePreorderResultReducer = createReducer(
  encryptDutyFreePreorderResultInitialState,
  ...encryptDutyFreePreorderResultReducerFeatures
);
